module.exports = __webpack_public_path__ + "static/media/SuiteC05.3d6db32b.jpg";